import { useState, useEffect, useRef } from 'react'
import DateTimeFormat from '../../../util/DateTimeformat'
import { GetChatLog, Get_tickets, update_tickets } from '../../../services/data'
import { apiFetch } from '../../../services/apihelper'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import Conversation from '../conversation'
import { faHistory } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import validateJSON from '../../../util/jsonvalidation'
import Cookies from 'js-cookie'
import { useAuth } from '../../../context/logincontext'
import { useLocation, useParams } from 'react-router-dom'

const MobileViewChat = () => {
  const [CustomerList, SetCustomerList] = useState([])
  const [selectedValue, setSelectedValue] = useState([])
  const [Initialactive, SetInitialactive] = useState('')
  const [CustomerChatList, SetCustomerChatList] = useState([])
  const [groupedChats, setGroupedChats] = useState({})
  const [currentScreen, setCurrentScreen] = useState('list') // Screen management
  const [activeCustomer, setActiveCustomer] = useState(null) // Active customer details
  const [selectedDate, setSelectedDate] = useState(new Date()) // State to store selected date
  const [showModal, setShowModal] = useState(false) // For controlling the modal visibility
  const [deletingChat, setDeletingChat] = useState(null) // For storing the chat ID to delete
  const chatLog = new GetChatLog()
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)
  const dropdownMenuRef = useRef(null)
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null)
  const contentListRef = useRef(null)
  const [sortlist, setSortlist] = useState('')
  const [checkfilter, setCheckfilter] = useState('')
  const [ticketemail, Setticketemail] = useState('')
  const [ticketsList, setTicketList] = useState([])
  const {userdata} = useAuth()
  const location = useLocation()
  const params = useParams()
  
    // ✅ Extract store_id from URL (params or pathname)
    const getStoreIdFromUrl = () => {
      if (params?.store_id) return params.store_id
      const pathParts = location.pathname.split('/')
      console.log(pathParts[1])
      return pathParts[1] || null
    }
  
    const store_id = getStoreIdFromUrl()

  useEffect(() => {
    if (ticketsList) {
      // Initialize selectedValue with status from ticketsList, fallback to '---' if status is missing
      setSelectedValue(ticketsList.map(item => item.status || '---'))
    }
  }, [ticketsList])

  useEffect(() => {
    const controller = new AbortController() // Create a new AbortController instance
    const { signal } = controller // Extract the signal
    const checkCutomerId = async (cust_id, storeID) => {
      const customerChatlist = await chatLog.Get_Chat_List(
        storeID,
        cust_id,
        signal
      )
      if (customerChatlist.success) {
        if (customerChatlist.data.length > 0) {
          SetInitialactive(customerChatlist.data[0].chat_id)
          SetCustomerChatList(customerChatlist.data)
          localStorage.setItem(
            'chatlist_customer_id',
            customerChatlist.data[0].chat_id
          )
          window.dispatchEvent(
            new CustomEvent('chatlist_customer_id', { detail: true })
          )
        }
      }
    }

    if (
      localStorage.getItem('chatlog_customer_id') &&
      store_id
    ) {
      checkCutomerId(
        localStorage.getItem('chatlog_customer_id'),
        store_id
      )
    }

    const handleGetNewCustomerID = event => {
      if (event.detail === true) {
        if (
          localStorage.getItem('chatlog_customer_id') &&
          store_id
        ) {
          checkCutomerId(
            localStorage.getItem('chatlog_customer_id'),
            store_id
          )
          window.dispatchEvent(
            new CustomEvent('loadchatlist', { detail: true })
          )
        }
        const ticketEmail = localStorage.getItem('chatlog_customer_email')
        Setticketemail(ticketEmail)
      }
    }

    window.addEventListener('deletereload', handleGetNewCustomerID)
    window.addEventListener('chatlog_customer_id', handleGetNewCustomerID)
    return () => {
      window.removeEventListener('chatlog_customer_id', handleGetNewCustomerID)
      window.removeEventListener('deletereload', handleGetNewCustomerID)
      controller.abort() // Abort the fetch request if the component is unmounted or if the effect cleanup happens
    }
  }, [])

  useEffect(() => {
    // Group chat items by formatted date
    const groupChatsByDate = () => {
      const grouped = CustomerChatList.reduce((acc, item) => {
        const formattedDate = DateTimeFormat(item.last_message_time).date
        if (!acc[formattedDate]) {
          acc[formattedDate] = []
        }
        acc[formattedDate].push(item)
        return acc
      }, {})

      setGroupedChats(grouped)
    }

    if (CustomerChatList.length > 0) {
      groupChatsByDate()
    }
  }, [CustomerChatList])

  const handleActiveChatid = id => {
    localStorage.setItem('chatlist_customer_id', id)
    window.dispatchEvent(
      new CustomEvent('chatlist_customer_id', { detail: true })
    )
    SetInitialactive(id)
    setIsMenuOpen(false)
    // setCurrentScreen('conversation')
  }

  const handleDateChange = date => {
    setSelectedDate(date)
    const formattedDate = DateTimeFormat(date).date
    // Filter chats based on selected date
    const filteredChats = CustomerChatList.filter(
      item => DateTimeFormat(item.last_message_time).date === formattedDate
    )
    setGroupedChats({ [formattedDate]: filteredChats })
  }

  const DatepickerCustomInput = ({ value, onClick }) => (
    <div
      className='w-full h-[39px] cursor-pointer border-[0.4px] gap-2 border-[#C6C6C6] border-opacity-[50%] rounded-[40px] flex justify-center items-center bg-[#FFFFFF80] focus:outline-none'
      onClick={onClick}
    >
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M16.875 4.49971C16.875 3.90297 16.6379 3.33067 16.216 2.90871C15.794 2.48676 15.2217 2.2497 14.625 2.2497H14.0625V1.70302C14.0625 1.40033 13.8298 1.14052 13.5271 1.12541C13.451 1.12174 13.375 1.13356 13.3037 1.16014C13.2323 1.18672 13.1671 1.2275 13.112 1.28003C13.0568 1.33256 13.0129 1.39573 12.983 1.46572C12.953 1.53571 12.9375 1.61106 12.9375 1.6872V2.2497H5.0625V1.70302C5.0625 1.40033 4.82977 1.14052 4.52707 1.12541C4.45101 1.12174 4.37501 1.13356 4.30365 1.16014C4.2323 1.18672 4.16708 1.2275 4.11196 1.28003C4.05684 1.33256 4.01295 1.39573 3.98296 1.46572C3.95297 1.53571 3.93751 1.61106 3.9375 1.6872V2.2497H3.375C2.77826 2.2497 2.20597 2.48676 1.78401 2.90871C1.36205 3.33067 1.125 3.90297 1.125 4.49971V4.92158C1.125 4.95888 1.13982 4.99464 1.16619 5.02102C1.19256 5.04739 1.22833 5.06221 1.26562 5.06221H16.7344C16.7717 5.06221 16.8074 5.04739 16.8338 5.02102C16.8602 4.99464 16.875 4.95888 16.875 4.92158V4.49971Z'
          fill='#565656'
        />
        <path
          d='M1.125 14.6247C1.125 15.2214 1.36205 15.7937 1.78401 16.2157C2.20597 16.6377 2.77826 16.8747 3.375 16.8747H14.625C15.2217 16.8747 15.794 16.6377 16.216 16.2157C16.6379 15.7937 16.875 15.2214 16.875 14.6247V6.29267C16.875 6.2647 16.8639 6.23787 16.8441 6.2181C16.8243 6.19832 16.7975 6.1872 16.7695 6.1872H1.23047C1.2025 6.1872 1.17567 6.19832 1.15589 6.2181C1.13611 6.23787 1.125 6.2647 1.125 6.29267V14.6247ZM13.2188 7.3122C13.3856 7.3122 13.5488 7.36169 13.6875 7.4544C13.8263 7.54711 13.9344 7.67889 13.9983 7.83307C14.0621 7.98724 14.0788 8.15689 14.0463 8.32056C14.0137 8.48423 13.9334 8.63458 13.8154 8.75258C13.6974 8.87058 13.547 8.95094 13.3834 8.98349C13.2197 9.01605 13.05 8.99934 12.8959 8.93548C12.7417 8.87162 12.6099 8.76347 12.5172 8.62472C12.4245 8.48596 12.375 8.32283 12.375 8.15596C12.375 7.93218 12.4639 7.71757 12.6221 7.55933C12.7804 7.4011 12.995 7.3122 13.2188 7.3122ZM13.2188 10.1247C13.3856 10.1247 13.5488 10.1742 13.6875 10.2669C13.8263 10.3596 13.9344 10.4914 13.9983 10.6456C14.0621 10.7997 14.0788 10.9694 14.0463 11.1331C14.0137 11.2967 13.9334 11.4471 13.8154 11.5651C13.6974 11.6831 13.547 11.7634 13.3834 11.796C13.2197 11.8285 13.05 11.8118 12.8959 11.748C12.7417 11.6841 12.6099 11.576 12.5172 11.4372C12.4245 11.2985 12.375 11.1353 12.375 10.9685C12.375 10.7447 12.4639 10.5301 12.6221 10.3718C12.7804 10.2136 12.995 10.1247 13.2188 10.1247ZM10.4062 7.3122C10.5731 7.3122 10.7363 7.36169 10.875 7.4544C11.0138 7.54711 11.1219 7.67889 11.1858 7.83307C11.2496 7.98724 11.2663 8.15689 11.2338 8.32056C11.2012 8.48423 11.1209 8.63458 11.0029 8.75258C10.8849 8.87058 10.7345 8.95094 10.5709 8.98349C10.4072 9.01605 10.2375 8.99934 10.0834 8.93548C9.92919 8.87162 9.79741 8.76347 9.7047 8.62472C9.61199 8.48596 9.5625 8.32283 9.5625 8.15596C9.5625 7.93218 9.6514 7.71757 9.80963 7.55933C9.96786 7.4011 10.1825 7.3122 10.4062 7.3122ZM10.4062 10.1247C10.5731 10.1247 10.7363 10.1742 10.875 10.2669C11.0138 10.3596 11.1219 10.4914 11.1858 10.6456C11.2496 10.7997 11.2663 10.9694 11.2338 11.1331C11.2012 11.2967 11.1209 11.4471 11.0029 11.5651C10.8849 11.6831 10.7345 11.7634 10.5709 11.796C10.4072 11.8285 10.2375 11.8118 10.0834 11.748C9.92919 11.6841 9.79741 11.576 9.7047 11.4372C9.61199 11.2985 9.5625 11.1353 9.5625 10.9685C9.5625 10.7447 9.6514 10.5301 9.80963 10.3718C9.96786 10.2136 10.1825 10.1247 10.4062 10.1247ZM10.4062 12.9372C10.5731 12.9372 10.7363 12.9867 10.875 13.0794C11.0138 13.1721 11.1219 13.3039 11.1858 13.4581C11.2496 13.6122 11.2663 13.7819 11.2338 13.9456C11.2012 14.1092 11.1209 14.2596 11.0029 14.3776C10.8849 14.4956 10.7345 14.5759 10.5709 14.6085C10.4072 14.641 10.2375 14.6243 10.0834 14.5605C9.92919 14.4966 9.79741 14.3885 9.7047 14.2497C9.61199 14.111 9.5625 13.9478 9.5625 13.781C9.5625 13.5572 9.6514 13.3426 9.80963 13.1843C9.96786 13.0261 10.1825 12.9372 10.4062 12.9372ZM7.59375 10.1247C7.76063 10.1247 7.92376 10.1742 8.06251 10.2669C8.20127 10.3596 8.30941 10.4914 8.37327 10.6456C8.43713 10.7997 8.45384 10.9694 8.42129 11.1331C8.38873 11.2967 8.30837 11.4471 8.19037 11.5651C8.07237 11.6831 7.92203 11.7634 7.75836 11.796C7.59469 11.8285 7.42504 11.8118 7.27086 11.748C7.11669 11.6841 6.98491 11.576 6.8922 11.4372C6.79948 11.2985 6.75 11.1353 6.75 10.9685C6.75 10.7447 6.83889 10.5301 6.99713 10.3718C7.15536 10.2136 7.36997 10.1247 7.59375 10.1247ZM7.59375 12.9372C7.76063 12.9372 7.92376 12.9867 8.06251 13.0794C8.20127 13.1721 8.30941 13.3039 8.37327 13.4581C8.43713 13.6122 8.45384 13.7819 8.42129 13.9456C8.38873 14.1092 8.30837 14.2596 8.19037 14.3776C8.07237 14.4956 7.92203 14.5759 7.75836 14.6085C7.59469 14.641 7.42504 14.6243 7.27086 14.5605C7.11669 14.4966 6.98491 14.3885 6.8922 14.2497C6.79948 14.111 6.75 13.9478 6.75 13.781C6.75 13.5572 6.83889 13.3426 6.99713 13.1843C7.15536 13.0261 7.36997 12.9372 7.59375 12.9372ZM4.78125 10.1247C4.94813 10.1247 5.11126 10.1742 5.25001 10.2669C5.38877 10.3596 5.49691 10.4914 5.56077 10.6456C5.62463 10.7997 5.64134 10.9694 5.60879 11.1331C5.57623 11.2967 5.49587 11.4471 5.37787 11.5651C5.25987 11.6831 5.10953 11.7634 4.94586 11.796C4.78219 11.8285 4.61254 11.8118 4.45836 11.748C4.30419 11.6841 4.17241 11.576 4.0797 11.4372C3.98699 11.2985 3.9375 11.1353 3.9375 10.9685C3.9375 10.7447 4.02639 10.5301 4.18463 10.3718C4.34286 10.2136 4.55747 10.1247 4.78125 10.1247ZM4.78125 12.9372C4.94813 12.9372 5.11126 12.9867 5.25001 13.0794C5.38877 13.1721 5.49691 13.3039 5.56077 13.4581C5.62463 13.6122 5.64134 13.7819 5.60879 13.9456C5.57623 14.1092 5.49587 14.2596 5.37787 14.3776C5.25987 14.4956 5.10953 14.5759 4.94586 14.6085C4.78219 14.641 4.61254 14.6243 4.45836 14.5605C4.30419 14.4966 4.17241 14.3885 4.0797 14.2497C3.98699 14.111 3.9375 13.9478 3.9375 13.781C3.9375 13.5572 4.02639 13.3426 4.18463 13.1843C4.34286 13.0261 4.55747 12.9372 4.78125 12.9372Z'
          fill='#565656'
        />
      </svg>

      <p className='font-[500] text-[10px] leading-[13.66px] text-[#565656] truncate'>
        Select date
      </p>
    </div>
  )

  const handleDeleteClick = () => {
    // setDeletingChat(chatId);  // Set the chat ID to be deleted
    setShowModal(true) // Show the confirmation modal
  }

  const handleConfirmDelete = async () => {
    // Proceed with deletion (you can make the API call here)
    console.log(localStorage.getItem('chatlist_customer_id'))
    // console.log(CustomerChatList)
    // After deletion, hide the modal
    try {
      const response = await apiFetch(`chatlog/batch/delete/chat_id`, {
        method: 'POST',
        body: JSON.stringify({
          ids: [localStorage.getItem('chatlist_customer_id')]
        })
      })

      // console.log(response);
      if (response.success) {
        setShowModal(false)
        window.dispatchEvent(new CustomEvent('deletereload', { detail: true }))
        window.location.reload()
      }
    } catch (error) {}
  }

  const handleCancelDelete = async () => {
    // const chatlog = await chatLog.Get_Chat_Log(localStorage.getItem('chatlog_customer_id'), localStorage.getItem("store_id"));

    setShowModal(false)
  }

  const isColorDark = color => {
    const hex = color.replace('#', '')
    const r = parseInt(hex.substring(0, 2), 16)
    const g = parseInt(hex.substring(2, 4), 16)
    const b = parseInt(hex.substring(4, 6), 16)
    const brightness = (r * 299 + g * 587 + b * 114) / 1000
    return brightness < 128
  }

  const lightenColor = (color, percent = 0.5) => {
    const num = parseInt(color.replace('#', ''), 16)
    const amt = Math.round(2.55 * percent * 100)
    const r = (num >> 16) + amt
    const g = ((num >> 8) & 0x00ff) + amt
    const b = (num & 0x0000ff) + amt
    return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`
  }

  const getColorForCustomer = customerId => {
    const storedColor = localStorage.getItem(`color_${customerId}`)
    if (storedColor) {
      return storedColor
    } else {
      let randomColor = getRandomColor()
      if (isColorDark(randomColor)) {
        randomColor = lightenColor(randomColor)
      }
      localStorage.setItem(`color_${customerId}`, randomColor)
      return randomColor
    }
  }

  const getRandomColor = () => {
    const letters = '0123456789ABCDEF'
    let color = '#'
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)]
    }
    return color
  }

  useEffect(() => {
    const controller = new AbortController() // Create a new AbortController instance
    const { signal } = controller // Extract the signal
    const customer_chatlog = async storeId => {
      const customerlist = await chatLog.Get_Customer_List(storeId, signal)
      if (customerlist.success) {
        SetCustomerList(customerlist.data)
        SetInitialactive(customerlist?.data[0]?.customer_id)
        localStorage.setItem(
          'chatlog_customer_id',
          customerlist?.data[0]?.customer_id
        )
      } else {
        console.log(customerlist.success)
      }
    }

    if (store_id) {
      customer_chatlog(store_id)
    }

    const handlecustomerlog = () => {
      if (store_id) {
        customer_chatlog(store_id)
      }
    }

    window.addEventListener('deletereload', handlecustomerlog)

    return () => {
      window.removeEventListener('deletereload', handlecustomerlog)
      controller.abort() // Abort the fetch request if the component is unmounted or if the effect cleanup happens
    }
  }, [])

  const handleActiveCustomerid = id => {
    localStorage.setItem('chatlog_customer_id', id)
    window.dispatchEvent(
      new CustomEvent('chatlog_customer_id', { detail: true })
    )
    SetInitialactive(id)
    setActiveCustomer(
      CustomerList.find(customer => customer.customer_id === id)
    ) // Set active customer details
    setCurrentScreen('details') // Switch to details screen
  }

  const handleConversation = () => {
    setCurrentScreen('conversation') // Switch to conversation screen
  }

  const [isMenuOpen, setIsMenuOpen] = useState(false)

  // Toggle hamburger menu
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  const handleSelectChange = async event => {
    const value = event.target.value
    if (value === '') {
      setCheckfilter('')
      const storeID = store_id
      const cust_id = localStorage.getItem('chatlog_customer_id')
      const user_id = validateJSON(userdata).id
      // const user_id = validateJSON(Cookies.get('user')).id
      const ticketsListdata = await Get_tickets(storeID, cust_id, user_id)
      setTicketList(ticketsListdata.data)
      setSortlist(value)
    } else {
      const storeID = store_id
      const cust_id = localStorage.getItem('chatlog_customer_id')
      const user_id = validateJSON(userdata).id
      // const user_id = validateJSON(Cookies.get('user')).id
      // console.log(value)
      setCheckfilter(value)
      setSortlist(value)
      const ticketsListdata = await Get_tickets(
        storeID,
        cust_id,
        user_id,
        '',
        value
      )
      // console.log(ticketsListdata)
      setTicketList(ticketsListdata.data)
    }
  }

  const toggleDropdown = index => {
    setOpenDropdownIndex(openDropdownIndex === index ? null : index)
  }

  const handleSelection = async (ticketId, value) => {
    // // Create a copy of the current selectedValue state
    // const updatedValues = [...selectedValue]
    // // Update the specific index in the selected values array
    // const ticketIndex = ticketsList.findIndex(
    //   ticket => ticket.ticket_id === ticketId
    // )
    // updatedValues[ticketIndex] = value // Update the selected value for the specific dropdown
    // setSelectedValue(updatedValues) // Update the state
    // // Close the dropdown after making a selection
    // setOpenDropdownIndex(null)
    // console.log('Updated Selected Values:', updatedValues)
    // // Update the ticket on the server
    // const ticketUpdate = await update_tickets(ticketId, value)
    // if (ticketUpdate.success) {
    //   // Fetch updated tickets list
    //   const storeID = localStorage.getItem('store_id')
    //   const cust_id = localStorage.getItem('chatlog_customer_id')
    //   const user_id = JSON.parse(userdata).id
    //   const ticketsListData = await Get_tickets(storeID, cust_id, user_id)
    //   // Update the tickets list in the state
    //   setTicketList(ticketsListData.data)
    // }
  }

  // useEffect(() => {
  //   let ticketsListdata

  //   const GetTicketList = async (storeID, cust_id, user_id) => {
  //     ticketsListdata = await Get_tickets(storeID, cust_id, user_id)
  //     setTicketList(ticketsListdata.data)
  //   }

  //   const handleScroll = async () => {
  //     if (
  //       contentListRef.current &&
  //       contentListRef.current.scrollTop +
  //         contentListRef.current.clientHeight >=
  //         contentListRef.current.scrollHeight
  //     ) {
  //       // console.log('Scrolled to the bottom!')
  //       // console.log(sortlist)
  //       if (checkfilter === '') {
  //         return
  //       } else {
  //         const updateticket = ticketsListdata.pagination
  //         const initialLimit = updateticket.limit
  //         const initialTotal = updateticket.total
  //         const limitvalue = initialLimit - initialTotal
  //         const finallimitvalue = Math.abs(limitvalue) + initialLimit
  //         const storeID = localStorage.getItem('store_id')
  //         const cust_id = localStorage.getItem('chatlog_customer_id')
  //         const user_id = JSON.parse(userdata).id

  //         ticketsListdata = await Get_tickets(
  //           storeID,
  //           cust_id,
  //           user_id,
  //           finallimitvalue
  //         )
  //         setTicketList(ticketsListdata.data)
  //         // Add your logic for when scrolling reaches the bottom
  //       }
  //     }
  //   }

  //   const container = contentListRef.current
  //   if (container) {
  //     container.addEventListener('scroll', handleScroll)
  //   }

  //   GetTicketList()

  //   const hanldeGetTicketList = event => {
  //     if (event.detail) {
  //       const storeID = localStorage.getItem('store_id')
  //       const cust_id = localStorage.getItem('chatlog_customer_id')
  //       const user_id = JSON.parse(userdata).id
  //       GetTicketList(storeID, cust_id, user_id)
  //     }
  //   }
  //   window.addEventListener('chatlog_customer_id', hanldeGetTicketList)

  //   return () => {
  //     window.removeEventListener('chatlog_customer_id', hanldeGetTicketList)
  //     if (container) {
  //       container.removeEventListener('scroll', handleScroll)
  //     }
  //   }
  // }, [])

  const renderCustomerList = () => (
    <div className='pt-5 pl-3'>
      <h1 className='font-extrabold text-[23px] leading-[48px] sm:text-[18px] sm:leading-[28px]'>
        Chats
      </h1>
      <div className='block '>
        <div className=''>
          <div className='flex flex-col mt-6 gap-5 mb-9 max-h-[270px] sm:max-h-[200px] overflow-x-hidden scrollbar-custom1'>
            {CustomerList.map((item, index) => {
              const customerColor = getColorForCustomer(item.customer_id)
              return (
                <div
                  key={index}
                  className={`w-full sm:w-[95%] h-[54px] sm:h-[50px] hover:bg-white rounded-full cursor-pointer px-[11px] py-[7px] flex items-center justify-between gap-2 ${
                    Initialactive === item.customer_id && ''
                  }`}
                  onClick={() => handleActiveCustomerid(item.customer_id)}
                >
                  <div className='flex items-center gap-3'>
                    <div
                      className='w-8 h-8 sm:w-7 sm:h-7 rounded-full flex items-center justify-center'
                      style={{ backgroundColor: customerColor }}
                    >
                      {item.customer_id.charAt(0).toUpperCase()}
                    </div>
                    <div className='flex flex-col gap-1'>
                      <p className='font-semibold text-[18px] sm:text-[12px] text-[#444444] leading-[17.76px] text-wrap w-[100%] md:w-[100px] overflow-hidden truncate'>
                        {item.customer_id}
                      </p>
                      <p className='font-normal text-[14px] sm:text-[10px] text-[#444444] leading-[15.03px]'>
                        {DateTimeFormat(item.last_message_time).date}
                      </p>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )

  //   const renderCustomerDetails = () => (
  //     <div className="pt-5 pl-3 sm:px-6">
  //     <div className="border-b-[1px] flex justify-between items-center pr-5 pl-5 cursor-pointer border-[#E5E9EB] w-full h-[70px]">
  //         <svg
  //           width='34'
  //           height='34'
  //           viewBox='0 0 34 34'
  //           fill='none'
  //           xmlns='http://www.w3.org/2000/svg'
  //           onClick={handleDeleteClick}
  //         >
  //           <circle cx='17' cy='17' r='16.5' fill='#FAFAFA' stroke='#D1D1D1' />
  //           <path
  //             fill-rule='evenodd'
  //             clip-rule='evenodd'
  //             d='M15.7485 11C15.7159 10.9999 15.6835 11.0063 15.6533 11.0187C15.6231 11.0312 15.5957 11.0495 15.5726 11.0726C15.5495 11.0957 15.5312 11.1231 15.5187 11.1533C15.5063 11.1835 15.4999 11.2159 15.5 11.2485L15.5 11.25V12H18.5V11.25L18.5 11.2485C18.5001 11.2159 18.4937 11.1835 18.4813 11.1533C18.4688 11.1231 18.4505 11.0957 18.4274 11.0726C18.4043 11.0495 18.3769 11.0312 18.3467 11.0187C18.3165 11.0063 18.2841 10.9999 18.2515 11L18.25 11H15.75L15.7485 11ZM13.0322 13L13.624 22.4688C13.6241 22.4707 13.6242 22.4725 13.6243 22.4743C13.6416 22.8108 13.865 23 14.125 23H19.875C20.1324 23 20.3548 22.8151 20.3759 22.4695L20.9678 13H13.0322ZM21.4954 12H19.5V11.2507C19.5004 11.0865 19.4683 10.9238 19.4057 10.772C19.343 10.6199 19.2508 10.4818 19.1345 10.3655C19.0182 10.2492 18.8801 10.157 18.728 10.0943C18.5762 10.0317 18.4136 9.99963 18.2494 10H15.7506C15.5864 9.99963 15.4238 10.0317 15.272 10.0943C15.1199 10.157 14.9818 10.2492 14.8655 10.3655C14.7492 10.4818 14.657 10.6199 14.5943 10.772C14.5317 10.9238 14.4996 11.0864 14.5 11.2506V12H12.5046C12.5019 12 12.4991 12 12.4963 12H11.5C11.2239 12 11 12.2239 11 12.5C11 12.7761 11.2239 13 11.5 13H12.0303L12.6258 22.5287C12.6693 23.3464 13.286 24 14.125 24H19.875C20.722 24 21.3245 23.3406 21.3741 22.5306C21.3741 22.5306 21.3741 22.5305 21.3741 22.5305L21.9697 13H22.5C22.7761 13 23 12.7761 23 12.5C23 12.2239 22.7761 12 22.5 12H21.5037C21.5009 12 21.4981 12 21.4954 12ZM14.7322 14.0003C15.0081 13.9905 15.2398 14.2062 15.2497 14.4822L15.4997 21.4822C15.5095 21.7581 15.2938 21.9898 15.0178 21.9997C14.7419 22.0095 14.5102 21.7938 14.5003 21.5178L14.2503 14.5178C14.2405 14.2419 14.4562 14.0102 14.7322 14.0003ZM19.2678 14.0003C19.5438 14.0102 19.7595 14.2419 19.7497 14.5178L19.4997 21.5178C19.4898 21.7938 19.2581 22.0095 18.9822 21.9997C18.7062 21.9898 18.4905 21.7581 18.5003 21.4822L18.7503 14.4822C18.7602 14.2062 18.9919 13.9905 19.2678 14.0003ZM17 14C17.2761 14 17.5 14.2239 17.5 14.5V21.5C17.5 21.7761 17.2761 22 17 22C16.7239 22 16.5 21.7761 16.5 21.5V14.5C16.5 14.2239 16.7239 14 17 14Z'
  //             fill='#373737'
  //           />
  //         </svg>
  //       </div>
  //       {showModal && (
  //         <div className='fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50'>
  //           <div className='bg-[#F4F4F4] rounded-[24px] w-[456px] h-[240px] p-6 border-[1.6px] border-[#FFFFFF]  shadow[-1px_0px_0px_0px_inset]'>
  //             <div className='block'>
  //               <div className='w-full flex justify-end items-start '>
  //                 <svg
  //                   onClick={handleCancelDelete}
  //                   width='26'
  //                   height='26'
  //                   className='cursor-pointer'
  //                   viewBox='0 0 26 26'
  //                   fill='none'
  //                   xmlns='http://www.w3.org/2000/svg'
  //                 >
  //                   <path
  //                     fill-rule='evenodd'
  //                     clip-rule='evenodd'
  //                     d='M7.88702 6.73798C7.56972 6.42067 7.05528 6.42067 6.73798 6.73798C6.42067 7.05528 6.42067 7.56972 6.73798 7.88702L11.851 13L6.73798 18.113C6.42067 18.4303 6.42067 18.9447 6.73798 19.262C7.05528 19.5793 7.56972 19.5793 7.88702 19.262L13 14.149L18.113 19.262C18.4303 19.5793 18.9447 19.5793 19.262 19.262C19.5793 18.9447 19.5793 18.4303 19.262 18.113L14.149 13L19.262 7.88702C19.5793 7.56972 19.5793 7.05528 19.262 6.73798C18.9447 6.42067 18.4303 6.42067 18.113 6.73798L13 11.851L7.88702 6.73798Z'
  //                     fill='#373737'
  //                   />
  //                 </svg>
  //               </div>
  //               <div className=' mt-2 flex flex-col items-center justify-center gap-3'>
  //                 <p className='font-[800] text-[20px] leading-[38.25px] text-[#252530]'>
  //                   Delete
  //                 </p>
  //                 <p className='font-[400] text-[16px] leading-[21px]'>
  //                   Are you sure want to delete
  //                 </p>
  //                 <div className='flex mt-4 gap-4'>
  //                   <button
  //                     onClick={handleCancelDelete}
  //                     className='bg-[#232328] w-[136px] h-[39px] p-[10px] font-[600] text-[14px] leading-[19.12px] rounded-[39px] text-[#FFFFFF]'
  //                   >
  //                     Cancel
  //                   </button>
  //                   <button
  //                     onClick={handleConfirmDelete}
  //                     className='bg-[#E22400] w-[136px] h-[39px] p-[10px] font-[600] text-[14px] leading-[19.12px] rounded-[39px] text-[#FFFFFF]'
  //                   >
  //                     Delete
  //                   </button>
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       )}
  //       {/* Back Button with Left Arrow */}
  //       <div className=' mb-4'>
  //         <button
  //           className='flex items-center justify-center text-black-500 text-sm sm:text-base'
  //           onClick={() => setCurrentScreen('list')}
  //         >
  //           {/* Left Arrow */}
  //           <span className='mr-2 text-xl sm:text-2xl'>{`←`}</span>
  //           <p className='mt-1'>Back</p>
  //         </button>
  //       </div>

  //       <div className='block mt-5'>
  //         {/* Date Picker */}
  //         <div className='w-full mb-5'>
  //           <DatePicker
  //             selected={selectedDate}
  //             onChange={handleDateChange}
  //             customInput={<DatepickerCustomInput />}
  //             dateFormat='MMMM dd, yyyy'
  //           />
  //         </div>

  //         {/* Chats Grouped by Date */}
  //         <div className='flex flex-col items-start gap-4 overflow-x-hidden max-h-[220px] scrollbar-custom'>
  //           {Object.keys(groupedChats).map(key => (
  //             <div
  //               className='flex flex-col items-start gap-2 cursor-pointer'
  //               key={key}
  //             >
  //               <p className='text-[#000000] text-[22px] font-[600] leading-[16.9px] ml-2'>
  //                 {key}
  //               </p>
  //               {groupedChats[key].map((item, index) => (
  //                 <div
  //                   className={`w-[180px] sm:w-[220px] max-w-[200px] h-[42px] hover:bg-[#F0EEEE] rounded-[30px] flex items-center mb-2 ${
  //                     Initialactive === item.chat_id ? 'bg-[#D3D3D3]' : ''
  //                   }`}
  //                   key={index}
  //                   onClick={() => handleActiveChatid(item.chat_id)}
  //                 >
  //                   <p className='ml-2 font-[500] text-[19px] leading-[16.39px] pt-[10px] pr-[10px] pb-[10px] pl-[4px] w-[100%] truncate'>
  //                     {item.content}
  //                   </p>
  //                 </div>
  //               ))}
  //             </div>
  //           ))}
  //         </div>
  //       </div>
  //     </div>
  //   )

  const renderConversation = () => (
    <div className='pt-5 pl-3 flex'>
      {/* Left Menu Button */}
      <button
        className='flex items-center justify-center text-black-500 text-sm sm:text-base'
        onClick={() => setCurrentScreen('details')}
      >
        <span className='mr-2 text-xl sm:text-2xl'>{`←`}</span>
        <p className='mt-1'>Back</p>
      </button>

      {/* Conversation View */}
      <div className='ml-4 w-full'>
        <Conversation
          chatlistId={localStorage.getItem('chatlist_customer_id')}
        />
      </div>
    </div>
  )

  const renderCustomerDetails = () => (
    <div className='flex flex-col pt-5 pl-3 sm:px-6'>
      {/* Back Button */}
      <div className='flex items-center justify-between'>
        <div className='flex gap-4 items-center'>
          <button
            className='flex items-center text-sm sm:text-base text-black-500'
            onClick={() => setCurrentScreen('list')}
          >
            <p className='mr-2 mt-[-1.2px] text-xl sm:text-2xl'>{`←`}</p>
            <p className='mt-[1.8px]'>Back</p>
          </button>
        </div>
        {/* Hamburger Menu Toggle (Visible on smaller screens) */}
        <button
          className='sm:hidden p-2 mr-3'
          aria-label='Toggle Menu'
          onClick={toggleMenu}
        >
          {/* <svg
            width='30'
            height='30'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M4 6h16a1 1 0 1 1 0 2H4a1 1 0 1 1 0-2zm0 4h16a1 1 0 1 1 0 2H4a1 1 0 1 1 0-2zm0 4h16a1 1 0 1 1 0 2H4a1 1 0 1 1 0-2z'
              fill='#000'
            />
          </svg> */}
          <FontAwesomeIcon icon={faHistory} className='w-[40px] h-[20px]' />
        </button>
      </div>

      {showModal && (
        <div className='fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50'>
          <div className='bg-[#F4F4F4] rounded-[24px] w-[456px] h-[240px] p-6 border-[1.6px] border-[#FFFFFF]  shadow[-1px_0px_0px_0px_inset]'>
            <div className='block'>
              <div className='w-full flex justify-end items-start '>
                <svg
                  onClick={handleCancelDelete}
                  width='26'
                  height='26'
                  className='cursor-pointer'
                  viewBox='0 0 26 26'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    d='M7.88702 6.73798C7.56972 6.42067 7.05528 6.42067 6.73798 6.73798C6.42067 7.05528 6.42067 7.56972 6.73798 7.88702L11.851 13L6.73798 18.113C6.42067 18.4303 6.42067 18.9447 6.73798 19.262C7.05528 19.5793 7.56972 19.5793 7.88702 19.262L13 14.149L18.113 19.262C18.4303 19.5793 18.9447 19.5793 19.262 19.262C19.5793 18.9447 19.5793 18.4303 19.262 18.113L14.149 13L19.262 7.88702C19.5793 7.56972 19.5793 7.05528 19.262 6.73798C18.9447 6.42067 18.4303 6.42067 18.113 6.73798L13 11.851L7.88702 6.73798Z'
                    fill='#373737'
                  />
                </svg>
              </div>
              <div className=' mt-2 flex flex-col items-center justify-center gap-3'>
                <p className='font-[800] text-[20px] leading-[38.25px] text-[#252530]'>
                  Delete
                </p>
                <p className='font-[400] text-[16px] leading-[21px]'>
                  Are you sure want to delete
                </p>
                <div className='flex mt-4 gap-4'>
                  <button
                    onClick={handleCancelDelete}
                    className='bg-[#232328] w-[136px] h-[39px] p-[10px] font-[600] text-[14px] leading-[19.12px] rounded-[39px] text-[#FFFFFF]'
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleConfirmDelete}
                    className='bg-[#232328] w-[136px] h-[39px] p-[10px] font-[600] text-[14px] leading-[19.12px] rounded-[39px] text-[#FFFFFF]'
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Header Section */}
      <header className='border-b-[1px] border-[#E5E9EB] w-full h-[70px] flex justify-end  items-center px-5'>
        <button
          aria-label='Delete'
          onClick={handleDeleteClick}
          className='flex items-center justify-center'
        >
          <svg
            width='34'
            height='34'
            viewBox='0 0 34 34'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <circle cx='17' cy='17' r='16.5' fill='#FAFAFA' stroke='#D1D1D1' />
            <path
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M15.7485 11C15.7159 10.9999 15.6835 11.0063 15.6533 11.0187C15.6231 11.0312 15.5957 11.0495 15.5726 11.0726C15.5495 11.0957 15.5312 11.1231 15.5187 11.1533C15.5063 11.1835 15.4999 11.2159 15.5 11.2485L15.5 11.25V12H18.5V11.25L18.5 11.2485C18.5001 11.2159 18.4937 11.1835 18.4813 11.1533C18.4688 11.1231 18.4505 11.0957 18.4274 11.0726C18.4043 11.0495 18.3769 11.0312 18.3467 11.0187C18.3165 11.0063 18.2841 10.9999 18.2515 11L18.25 11H15.75L15.7485 11ZM13.0322 13L13.624 22.4688C13.6241 22.4707 13.6242 22.4725 13.6243 22.4743C13.6416 22.8108 13.865 23 14.125 23H19.875C20.1324 23 20.3548 22.8151 20.3759 22.4695L20.9678 13H13.0322ZM21.4954 12H19.5V11.2507C19.5004 11.0865 19.4683 10.9238 19.4057 10.772C19.343 10.6199 19.2508 10.4818 19.1345 10.3655C19.0182 10.2492 18.8801 10.157 18.728 10.0943C18.5762 10.0317 18.4136 9.99963 18.2494 10H15.7506C15.5864 9.99963 15.4238 10.0317 15.272 10.0943C15.1199 10.157 14.9818 10.2492 14.8655 10.3655C14.7492 10.4818 14.657 10.6199 14.5943 10.772C14.5317 10.9238 14.4996 11.0864 14.5 11.2506V12H12.5046C12.5019 12 12.4991 12 12.4963 12H11.5C11.2239 12 11 12.2239 11 12.5C11 12.7761 11.2239 13 11.5 13H12.0303L12.6258 22.5287C12.6693 23.3464 13.286 24 14.125 24H19.875C20.722 24 21.3245 23.3406 21.3741 22.5306C21.3741 22.5306 21.3741 22.5305 21.3741 22.5305L21.9697 13H22.5C22.7761 13 23 12.7761 23 12.5C23 12.2239 22.7761 12 22.5 12H21.5037C21.5009 12 21.4981 12 21.4954 12ZM14.7322 14.0003C15.0081 13.9905 15.2398 14.2062 15.2497 14.4822L15.4997 21.4822C15.5095 21.7581 15.2938 21.9898 15.0178 21.9997C14.7419 22.0095 14.5102 21.7938 14.5003 21.5178L14.2503 14.5178C14.2405 14.2419 14.4562 14.0102 14.7322 14.0003ZM19.2678 14.0003C19.5438 14.0102 19.7595 14.2419 19.7497 14.5178L19.4997 21.5178C19.4898 21.7938 19.2581 22.0095 18.9822 21.9997C18.7062 21.9898 18.4905 21.7581 18.5003 21.4822L18.7503 14.4822C18.7602 14.2062 18.9919 13.9905 19.2678 14.0003ZM17 14C17.2761 14 17.5 14.2239 17.5 14.5V21.5C17.5 21.7761 17.2761 22 17 22C16.7239 22 16.5 21.7761 16.5 21.5V14.5C16.5 14.2239 16.7239 14 17 14Z'
              fill='#373737'
            />
          </svg>
        </button>
      </header>

      {/* Hamburger Menu */}
      {isMenuOpen && (
        <div className='fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-start'>
          <aside
            className='bg-white w-[250px] h-full shadow-lg p-6'
            role='dialog'
            aria-label='Menu'
          >
            <button className='text-xl font-semibold mb-4' onClick={toggleMenu}>
              <svg
                width='14'
                height='14'
                viewBox='0 0 14 14'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  fill-rule='evenodd'
                  clip-rule='evenodd'
                  d='M1.88702 0.737976C1.56972 0.420675 1.05528 0.420675 0.737976 0.737976C0.420675 1.05528 0.420675 1.56972 0.737976 1.88702L5.85095 7L0.737976 12.113C0.420675 12.4303 0.420675 12.9447 0.737976 13.262C1.05528 13.5793 1.56972 13.5793 1.88702 13.262L7 8.14905L12.113 13.262C12.4303 13.5793 12.9447 13.5793 13.262 13.262C13.5793 12.9447 13.5793 12.4303 13.262 12.113L8.14905 7L13.262 1.88702C13.5793 1.56972 13.5793 1.05528 13.262 0.737976C12.9447 0.420675 12.4303 0.420675 12.113 0.737976L7 5.85095L1.88702 0.737976Z'
                  fill='#373737'
                />
              </svg>
            </button>
            <button
              onClick={() => setCurrentScreen('ticketlist')}
              className='text-[12px] bg-black text-white px-5 py-1 flex items-center font-medium rounded-[54px] hidden'
            >
              Ticket List
            </button>

            {/* Date Picker and Chat List */}
            <div className='mt-5'>
              <div className='mb-5'>
                <DatePicker
                  selected={selectedDate}
                  onChange={handleDateChange}
                  customInput={<DatepickerCustomInput />}
                  dateFormat='MMMM dd, yyyy'
                />
              </div>

              {/* Chat Groups */}
              <div className='overflow-y-auto max-h-[220px]  scrollbar-custom'>
                {Object.keys(groupedChats).map(key => (
                  <ChatGroup
                    key={key}
                    groupTitle={key}
                    chats={groupedChats[key]}
                    activeChatId={Initialactive}
                    onChatClick={handleActiveChatid}
                  />
                ))}
              </div>
            </div>
          </aside>
        </div>
      )}

      {/* Conversation Area */}
      <main className='flex-1 w-full'>
        <Conversation
          chatlistId={localStorage.getItem('chatlist_customer_id')}
        />
      </main>
    </div>
  )

  const ChatGroup = ({ groupTitle, chats, activeChatId, onChatClick }) => (
    <div className='flex flex-col items-start gap-2 mb-2 '>
      {/* Group Title */}
      <p className='text-[15px] font-semibold text-[#000000] ml-2'>
        {groupTitle}
      </p>

      {/* Chat Items */}
      {chats.map(item => (
        <div
          key={item.chat_id}
          className={`w-[180px] sm:w-[220px] max-w-[200px] h-[42px] flex items-center rounded-[5px]   cursor-pointer border-b-[1px] 
           ${Initialactive === item.chat_id && 'bg-[#F0EEEE]'}`}
          onClick={() => onChatClick(item.chat_id)}
        >
          <p className='truncate  text-[12px] font-semibold w-full p-2'>
            {item.content}
          </p>
        </div>
      ))}
    </div>
  )

  const ticketlist = () => (
    <div className='bg-white w-[88vw] ml-2 rounded-[16px] px-4 py-2 mt-5 mb-5 '>
      <button
        className='flex items-center justify-center text-black-500 text-sm sm:text-base'
        onClick={() => setCurrentScreen('list')}
      >
        <span className='mr-2 text-xl sm:text-2xl'>{`←`}</span>
        <p className='mt-1'>Back</p>
      </button>
      <h1 className='font-extrabold text-[18px] leading-[48px] text-center'>
        Customer Information
      </h1>
      <div className='flex flex-col'>
        <div className='flex gap-2'>
          <label className='text-[13px] font-semibold'>Email:</label>
          <p className='text-[13px]'>
            {ticketemail === 'null' ? '' : ticketemail}
          </p>
        </div>
        <div className='mt-8 border-b-[1px] pb-4'>
          <form className='w-full flex flex-col md:flex-row justify-between items-center'>
            <p className='font-semibold text-sm md:text-base'>Tickets</p>
            <select
              className='w-full md:w-[44%] border-[1px] pl-3 focus:outline-none border-opacity-25 text-xs md:text-sm border-black py-1 rounded-md mt-2 md:mt-0'
              onChange={handleSelectChange}
              value={sortlist}
            >
              <option value=''>All</option>
              <option value='open'>Open</option>
              <option value='inprogress'>In Progress</option>
              <option value='resolved'>Resolved</option>
              <option value='closed'>Closed</option>
            </select>
          </form>
        </div>
        <div
          className='max-h-[290px] overflow-y-auto content-list-scroll'
          ref={contentListRef}
        >
          {ticketsList?.map((item, index) => (
            <div key={index} className='mt-5'>
              <div className='flex flex-wrap border-gray-300 rounded-md'>
                <div
                  className='flex-grow px-2 py-1 text-sm outline-none border-[1px] rounded-lg focus:outline-none'
                  placeholder=''
                  readOnly
                >
                  {item.content}
                </div>
                <div className='relative dropdown'>
                  <button
                    type='button'
                    className='flex items-center bg-gray-100 text-gray-700 px-3 py-1 text-sm border-l border-gray-300 hover:bg-gray-200 truncate absolute right-0 top-0 md:top-[0.9px] rounded-lg'
                    aria-haspopup='true'
                    aria-expanded={
                      openDropdownIndex === index ? 'true' : 'false'
                    }
                    onClick={() => toggleDropdown(index)}
                  >
                    {selectedValue[index]?.charAt(0).toUpperCase() +
                      selectedValue[index]?.slice(1)}
                    <svg
                      className='w-3 h-3 ml-1'
                      xmlns='http://www.w3.org/2000/svg'
                      fill='none'
                      viewBox='0 0 24 24'
                      stroke='currentColor'
                    >
                      <path
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        strokeWidth='2'
                        d='M19 9l-7 7-7-7'
                      />
                    </svg>
                  </button>

                  {/* Dropdown Menu */}
                  {openDropdownIndex === index && (
                    <ul className='absolute right-0 mt-2 w-[150px] sm:w-40 bg-white border border-gray-300 rounded-md shadow-lg z-10'>
                      {['open', 'inprogress', 'resolved', 'closed'].map(
                        value => (
                          <li key={value}>
                            <a
                              href='#'
                              className='block px-3 py-1 text-sm text-gray-700 hover:bg-gray-100'
                              onClick={() =>
                                handleSelection(
                                  item.ticket_id,
                                  value.toLowerCase()
                                )
                              }
                            >
                              {value.charAt(0).toUpperCase() +
                                value.slice(1).toLowerCase()}
                            </a>
                          </li>
                        )
                      )}
                    </ul>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )

  const renderScreen = () => {
    switch (currentScreen) {
      case 'list':
        return renderCustomerList()
      case 'details':
        return renderCustomerDetails()
      case 'conversation':
        return renderConversation()
      case 'ticketlist':
        return ticketlist()
      default:
        return renderCustomerList()
    }
  }

  return <>{renderScreen()}</>
}

export default MobileViewChat
